export enum PhoneTypeEnum {
	NotFound = 0,
	Mobile,
	Home,
	Work
}
